import File from './file.vue';

export default File;


// WEBPACK FOOTER //
// ./src/components/inputs/file/index.js